import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import Notification from './Notification';
import './Main.css';
import CitiesTable from './TablesManager';
import { isVisible } from '@testing-library/user-event/dist/utils';
import backImage from '../src/pics/back.webp';
import chel from '../src/pics/chel.png';
import title from '../src/pics/title.png';
import tree from '../src/pics/tree.png';
import leaf from '../src/pics/leaf.png';
import chel2 from '../src/pics/chel2.png';
import admin from '../src/pics/admin.png';
import { concertsData } from './concertsData';
import { songsData } from './songsData';

Modal.setAppElement('#root');
export default class Home extends Component { 

  // формирование способа получения данных из базы
  constructor(props) {
    super(props);
    this.state = {
      concerts: null,
      songs: null,
      errors: {},
      notification: {
        message: '',
        type: '',
        isVisible: false
      },
      isModalOpen: false,
      userLogin: '',
      userPassword: '',
      isAdminAuthenticated: false,
    };
    this.handleSongClick = this.handleSongClick.bind(this);
  }

  componentDidMount(){
    this.fetchConcerts();
    this.fetchSongs();
    const elements = [
      '.maininfoimgtree',
      '.maininfotext'
    ]; 
    const observer = new IntersectionObserver(entries => { 
      entries.forEach(entry => { 
        const ind = [...document.querySelectorAll(elements.join(', '))].indexOf(entry.target);
        if (entry.isIntersecting) { 
          setTimeout(() => {
            entry.target.classList.add('visible');
            entry.target.classList.remove('hidden');
          }, ind * 800);
        } else {
          setTimeout(() => {
            entry.target.classList.add('hidden');
            entry.target.classList.remove('visible');
          }, ind * 100);
        } 
      }); 
    }, { 
      threshold: 0.1 // Процент видимости элемента, при котором запускается callback 
    }); 
    elements.forEach(selector => { 
      const nodes = document.querySelectorAll(selector);
      nodes.forEach(node => observer.observe(node));
    }); 
  }
  
  fetchConcerts() {
    this.setState({ concerts: concertsData });
  }

  fetchSongs() {
    this.setState({ songs: songsData });
  }

  selectsong = (e, mus) => {
    e.preventDefault();
    window.open(mus,'_blank','noopener,noreferrer');
  }

  // функция для форматирования даты перед выводом её на страницу
  formatDate(date) {
    const chapters=date.split('-');
    const m=chapters[1];
    const d=chapters[2];
    return `${d}.${m}`;
  }

  toggleModal=()=>{
    this.setState(prevState=>({
      isModalOpen: !prevState.isModalOpen,
      errors: {}
    }));
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }
  
  closeNotification=()=>{
    this.setState({
      notification: {
        message: '',
        type: '',
        isVisible: false
      }
    });
  }

  handleSongClick = (albumId) => {
    const state = { albumId };
    const stateString = encodeURIComponent(JSON.stringify(state));
    window.location.href = `http://localhost:3000/music?state=${stateString}`;
  }

  render() {
    const { notification, isModalOpen, userLogin, userPassword, isAdminAuthenticated, admincities } = this.state;
    if (!isAdminAuthenticated) {
    return (
      <div className='main'>
        <section>
          <div className='mainbody'>
            <img className='mainbodylampimg' src={chel} alt='' />
            <div className='mainflexbody'>
              <div className='modernmens'>
                <p className='modernmenstext'>
                  СОВРЕМЕННЫЙ МЕНЕСТРЕЛЬ
                </p>
              </div>
              <img className='mainbodytitleimg' src={title} alt='' />
              <div className='buttonbuy'>
                <Link to='http://localhost:3000/tickets' className='buttonbuytext'>
                  КУПИТЬ БИЛЕТЫ
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className='maininfo'>
            <img className='maininfoimgtree ' src={tree} alt='' />
            <div className='maininfotexts'>
              <img className='maininfoleaf1' src={leaf} alt='' />
              <img className='maininfoleaf2' src={leaf} alt='' />
              <p className='maininfotext'>
                лампабикт – музыкальный исполнитель, пишущий песни в жанре инди-фолк с 2019 года
              </p>
              <br />
              <p className='maininfotext'>
                песни о шорохе деревьев, выцветших чувствах, вечной осени, о детстве, которое давно исчезло, и зрелости, которая еще не наступила
              </p>
              <br />
              <p className='maininfotext'>
                музыкальное разнотравье, которое не дает промокнуть под дождем, оглохнуть от грома и замерзнуть от холода
              </p>
              <img className='maininfoleaf3' src={leaf} alt='' />
              <img className='maininfoleaf4' src={leaf} alt='' />
            </div>
          </div>
        </section>
        <section>
          <div className='mainconcerts'>
            <div className='mainconcertscol'>
              <div className='mainconcertsline'>
                <div className='mainconcertscolleft'>
                  {/* получение данных из базы */}
                  {this.state.concerts !== null ? 
                  this.state.concerts
                  .slice() // создание копии массива, чтобы не мутировать state
                  .sort((a, b) => new Date(a.concertdate) - new Date(b.concertdate)) // сортировка по дате
                  .slice(0, Math.floor(this.state.concerts.length / 2)) // разбивка массива на две части
                  .map((elem, index) => 
                  <Link 
                    to={`/tickets?city=${elem.name}`} 
                    className='mainconcertscolleftline' 
                    key={`left-${elem.id}`}
                  >
                    <p className='mainconcertscolleftline1'>{elem.name}</p>
                    <p className='mainconcertscolleftline2'>{this.formatDate(elem.concertdate)}</p>
                  </Link>) : null}
                </div>
                <img className='mainconcertsimg' src={chel2} alt='' />
                <div className='mainconcertscolright'>
                  {this.state.concerts !== null ? 
                  this.state.concerts
                  .slice() // создание копии массива
                  .sort((a, b) => new Date(a.concertdate) - new Date(b.concertdate)) // сортировка по дате
                  .slice(Math.floor(this.state.concerts.length / 2), this.state.concerts.length) // разбивка массива на две части
                  .map((elem, index) =>
                  <Link 
                    to={`/tickets?city=${elem.name}`}
                    className='mainconcertscolrightline'
                    key={`left-${elem.id}`}
                  >
                    <p className='mainconcertscolrightline2'>
                      {this.formatDate(elem.concertdate)}
                    </p>
                    <p className='mainconcertscolrightline1'>
                      {elem.name}
                    </p>
                  </Link>) : null}
                </div>
              </div>
              <div className='mainconcertsbuy'>
                <Link to='/tickets' className='mainconcertsbuytickets'>
                  КУПИТЬ БИЛЕТЫ
                </Link>
              </div>
              <div className='mainconcertstour'>
                <p className='mainconcertstourbuy'>
                  концертный тур
                </p>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className='mainsingle'>
            {this.state.songs !== null ?
            this.state.songs.slice(this.state.songs.length-1,this.state.songs.length).map((elem, index) => 
              <div className='mainsinglesql' key={`song-${elem.id}-${index}`}>
                <div className='mainsinglemusicline'>
                  {elem.youtube && <Link to='' className='mainsinglemusiclinechapters yt' onClick={(e) => this.selectsong(e,`${elem.youtube}`)} key={`yt-${elem.id}-${index}`} />}
                  {elem.deezer && <Link to='' className='mainsinglemusiclinechapters de' onClick={(e) => this.selectsong(e,`${elem.deezer}`)} key={`de-${elem.id}-${index}`} />}
                  {elem.vk && <Link to='' className='mainsinglemusiclinechapters vk' onClick={(e) => this.selectsong(e,`${elem.vk}`)} key={`vk-${elem.id}-${index}`} />}
                  {elem.spotify && <Link to='' className='mainsinglemusiclinechapters sp' onClick={(e) => this.selectsong(e,`${elem.spotify}`)} key={`sp-${elem.id}-${index}`} />}
                  {elem.yandex && <Link to='' className='mainsinglemusiclinechapters ya' onClick={(e) => this.selectsong(e,`${elem.yandex}`)} key={`ya-${elem.id}-${index}`} />}
                  {elem.apple && <Link to='' className='mainsinglemusiclinechapters ap' onClick={(e) => this.selectsong(e,`${elem.apple}`)} key={`ap-${elem.id}-${index}`} />}
                </div>
                <div className='mainsingleup'>
                  <div className='mainsinglename'>
                    <p className='mainsinglenametext'>
                      {elem.name}
                    </p>
                  </div>
                  <img className='mainsinglehouse' src={elem.image} alt='' onClick={() => this.handleSongClick(elem.albumid)} />
                  <div className='mainsinglenew'>
                    <p className='mainsinglenewtext'>
                      новая песня
                    </p>
                  </div>
                  <div className='mainsingleano'>
                    <Link to='http://localhost:3000/music' className='mainsingleanotext'>
                      ДРУГИЕ ПЕСНИ
                    </Link>
                  </div>
                </div>
              </div>
              ) : null }
              <div className='footer'>
                <div className='footerleft'>
                  <div className='footerleftline'>
                    <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                    <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                    <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                    <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
                  </div>
                  <div className='footerleftname'>
                    <p className='footerleftnametext'>
                      лампабикт.
                    </p>
                  </div>
                </div>
                <div className='footercenter'>
                  <a className='footercenterimg' />
                </div>
                <div className='footerright'>
                  <div className='footerrightline'>
                    <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                    <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                    <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
                  </div>
                </div>
                <img className='admin_button' src={admin} onClick={this.toggleModal} />
                <Modal isOpen={isModalOpen} onRequestClose={this.toggleModal} className='ticket_modal'>
                  <div className='modal_content'>
                    <h2 className='ticketmodal_txt'>Авторизация</h2>
                    <form className='ticketmodal_form'>
                      <div className='ticketmodal_inputstr'>
                        <label htmlFor='userLogin' className='ticketmodal_label'>Логин:</label>
                        <input type='text' id='userLogin' className='ticketmodal_input' name='userLogin' value={userLogin} onChange={this.handleInputChange} required />
                      </div>
                      <div className='ticketmodal_inputstr'>
                        <label htmlFor='userPassword' className='ticketmodal_label'>Пароль:</label>
                        <input type='password' id='userPassword' className='ticketmodal_input' name='userPassword' value={userPassword} onChange={this.handleInputChange} required />
                      </div>
                      <button type='button' onClick={this.handleLogin} className='ticketmodal_button_pay'>Войти</button>
                      </form>
                    <button onClick={this.toggleModal} className='ticketmodal_button_close'>Отмена</button>
                  </div>
                </Modal>
                {notification.isVisible&&(
                  <Notification message={notification.message} type={notification.type} onClose={this.closeNotification} />
                )}
            </div>
          </div>
        </section>
      </div>
    )} else {
      return (
        <div className='main'>
          <section>
            <div className='admin'>
              <CitiesTable cities={admincities} />
              <img className='adminbutton' src={admin} onClick={this.handleLogout} />
            </div>
          </section>
        </div>
      )
    }
  };
};

// функция для передачи значения города на страницу билетов
let cityname, base, content;
const selectcityl=(event)=> {
  cityname=event.currentTarget;
  base=cityname.querySelector('.mainconcertscolleftline1');
  content=base.textContent;
  window.location.href=`http://localhost:3000/tickets?city=${content}`;
};
const selectcityr=(event)=> {
  cityname=event.currentTarget;
  base=cityname.querySelector('.mainconcertscolrightline1');
  content=base.textContent;
  window.location.href=`http://localhost:3000/tickets?city=${content}`;
}